import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IEstimateTimePanelButtonProps } from './types';
import { ESTIMATE_TIME_TITLE } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function EstimateTimePanelButton ({
    isDisabled,
    tooltip,
    onClick
}: IEstimateTimePanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.ESTIMATE}
            isDisabled={isDisabled}
            title={ESTIMATE_TIME_TITLE}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.ESTIMATE);
                onClick();
            }}
        />
    );
}
